import './boka/style';
import FormStructure from './boka/form_structure';

export default FormStructure;